<template>
  <div class="MainBlock">
    <div class="profileHeader">
      <span class="profileTitle">MEU PERFIL</span>
      <slot />
    </div>

    <div class="mainInfo">
      <p class="titleProfile">Informações Principais</p>
      <p class="infoProfile">Nome: {{ account.name }}</p>
      <p class="infoProfile">Sobrenome: {{ account.surname }}</p>
      <p class="infoProfile">
        Cidade-UF: {{ account.city }} - {{ account.state }}
      </p>
      <p class="infoProfile">Universidade: {{ account.university }}</p>
      <p class="infoProfile">Curso: {{ account.course }}</p>
      <p class="infoProfile">
        Previsão de Formatura:
        <span v-if="account.graduationDate">
          {{ account.graduationDate }}
        </span>
        <span v-else class="inform"> Informar </span>
      </p>
    </div>
    <hr />

    <div class="mainInfo">
      <p class="titleProfile">Meus Contatos</p>

      <p class="infoProfile">
        Celular:
        <span v-if="account.cellphone">
          ({{ account.areacode }}) {{ account.cellphone }}
        </span>
        <span v-else class="inform"> Informar </span>
      </p>

      <p class="infoProfile">E-mail: {{ account.originalEmail }}</p>

      <p class="infoProfile">
        Facebook:
        <span v-if="account.facebook"> {{ account.facebook }} </span>
        <span v-else class="inform"> Informar </span>
      </p>

      <p class="infoProfile">
        Instagram:
        <span v-if="account.insta"> {{ account.insta }} </span>
        <span v-else class="inform"> Informar </span>
      </p>

      <p class="infoProfile">
        Linkedin:
        <span v-if="account.linkedin"> {{ account.linkedin }} </span>
        <span v-else class="inform"> Informar </span>
      </p>
    </div>

    <hr v-if="account.isOrganizationLeader" />

    <div class="mainInfo" v-if="account.isOrganizationLeader">
      <!-- <div class="mainInfo"> -->
      <p class="titleProfile">Informações da minha OE</p>
      <p class="infoProfile">Nome da sua OE: {{ oe.name }}</p>
      <p class="infoProfile">Categoria: {{ oe.category }}</p>
      <p class="infoProfile">Sua posição na OE: {{ account.position }}</p>
      <p class="infoProfile">
        E-mail Institucional da OE: {{ oe.organizationEmail }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "GeneralInfo",

  props: ["account"],

  computed: {
    oe() {
      return this.$store.state.organization.organization;
    }
  }
};
</script>

<style scoped>
.MainBlock {
  border: solid 0.5px rgb(175, 175, 175);
  border-radius: 0.5rem;
  margin-top: 0.5rem;
}
.profileHeader {
  background: rgb(2, 209, 168);
  background: linear-gradient(
    90deg,
    rgba(2, 209, 168, 1) 0%,
    rgba(95, 255, 223, 1) 100%,
    rgba(60, 247, 210, 1) 100%
  );
  border: transparent;
  border-radius: 0.5rem 0.5rem 0 0;
  display: flex;
}
.profileTitle {
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 2rem;
  margin-top: 0.5rem;
}
hr {
  margin: 0 !important;
}
.mainInfo {
  display: block;
  padding: 1rem 2rem;
}
.titleProfile {
  font-size: 1.3rem;
  font-weight: 600;
  color: rgb(97, 97, 97);
}
.mainInfo p {
  margin-top: 0.3rem;
  font-size: 1.2rem;
  color: rgb(70, 70, 70);
}

.inform {
  color: rgb(2, 209, 168);
}
</style>
